<template>
	<div class="#map"></div>
</template>

<script>


export default {
	name: 'ContactsMap',

	props: {
		coords: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			map: {
				center: this.coords,
				controls: ["zoomControl"],
				zoom: 6,
				settings: {
					apiKey: "",
					lang: "ru_RU"
				},
				options: {
					suppressMapOpenBlock: true
				},
				markerIcon: {
					layout: 'default#image',
					imageHref: require('@/assets/img/location.svg'),
					imageSize: [43, 43],
					imageOffset: [0, 0],
					contentOffset: [0, 15],
				}
			},
		}
	},
	async mounted() {
		await this.injectYMapsScript()
		await this.loadYMaps()
		this.initMap()
	},
	methods: {
		injectYMapsScript() {
			return new Promise(resolve => {
				const ymapsScript = document.createElement('script');
				ymapsScript.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU'
				document.body.appendChild(ymapsScript)
				ymapsScript.addEventListener('load', resolve)
			})
		},
		loadYMaps() {
			// eslint-disable-next-line
			return new Promise((resolve) => ymaps.ready(resolve));
		},
		initMap() {
			const map = document.querySelector('#map')
			// eslint-disable-next-line
			const contactMap = new ymaps.Map(map, {
				center: this.coords,
				behaviors: ['default'],
				zoom: 15,
				controls: []
			});
			// eslint-disable-next-line
			let PlacemarkPoint = new ymaps.Placemark(this.coords, {},
			{
				iconLayout: 'default#image',
				iconImageHref: require('@/assets/img/location.svg'),
				iconImageSize: [43, 43],
			});

			contactMap.geoObjects.add(PlacemarkPoint)
		}
	}
}
</script>

<style>

</style>
